import * as React from 'react';
import get from 'lodash/get';

import styles from './CheckBox.module.scss';

interface CheckboxProps {
  label: string | JSX.Element;
  checked?: boolean;
  name: string;
  onChange?: (name: string, value: boolean) => void;
  colorLabel?: string;
}

export default class Checkbox extends React.Component<CheckboxProps, {}> {
  private readonly onChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { onChange, name } = this.props;
    const value: boolean = get(event, 'target.checked');
    if (onChange !== undefined) {
      onChange(name, value);
    }
  };

  public render() {
    const { label, colorLabel, checked, name } = this.props;
    return (
      <label className={styles.check_box__container}>
        <div style={{ height: '100%', display: 'flex', paddingTop: 3 }}>
          <span style={{ color: colorLabel }} className={styles.check_box__label}>
            {label}
          </span>
        </div>
        <input
          name={name}
          className={styles.check_box__input}
          onChange={this.onChangeHandler}
          type="checkbox"
          checked={checked}
        />
        <span className={styles.check_box__check_mark} />
      </label>
    );
  }
}
